// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__35Vzq","title":"ClientInsurance_title__2nE5D","itemText":"ClientInsurance_itemText__3X2dn"};